import type { ReactNode } from "react";
import { type ThemeMode, useThemeStore } from "@/store/theme";

const svgProps = {
  width: 14,
  height: 14,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.75,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
  "aria-hidden": true,
};

const ICONS: Record<ThemeMode, ReactNode> = {
  system: (
    <svg {...svgProps}>
      <rect x="3" y="4" width="18" height="12" rx="2" />
      <path d="M8 20h8M12 16v4" />
    </svg>
  ),
  light: (
    <svg {...svgProps}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  ),
  dark: (
    <svg {...svgProps}>
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  ),
};

const OPTIONS: { value: ThemeMode; label: string }[] = [
  { value: "system", label: "System" },
  { value: "light", label: "Light" },
  { value: "dark", label: "Dark" },
];

/**
 * Compact three-way theme picker for the sidebar footer.
 * Renders as an inline segmented control.
 */
export function ThemePicker() {
  const { mode, setMode } = useThemeStore();

  return (
    <div className="theme-picker" role="group" aria-label="Color theme">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`theme-btn${mode === opt.value ? " active" : ""}`}
          aria-pressed={mode === opt.value}
          title={`${opt.label} theme`}
          onClick={() => setMode(opt.value)}
        >
          {ICONS[opt.value]}
          <span>{opt.label}</span>
        </button>
      ))}
    </div>
  );
}
